export default "__VITE_ASSET__hC2a$_DH__"